/* eslint-disable */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@wix/ambassador/runtime/http");
exports.AppMarketApi = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        Apps: function () {
            return function (headers) {
                var service = {
                    getAppsBySearchTag: function (getAppsBySearchTagRequest) {
                        return httpClient.invoke('GET', 'api/v1/apps/search-tags/{search_tag}', getAppsBySearchTagRequest, headers);
                    },
                    getInstalledApps: function (intalledAppsRequest) {
                        return httpClient.invoke('GET', 'api/v1/installed-apps', intalledAppsRequest, headers);
                    },
                    getKeywordsAndSlugHistory: function (appKeywordsAndSlugHistoryRequest) {
                        return httpClient.invoke('GET', 'api/v1/apps/{id_or_slug}/keywords', appKeywordsAndSlugHistoryRequest, headers);
                    },
                    managedApps: function (managedAppsRequest) {
                        return httpClient.invoke('GET', 'api/v1/managed-apps', managedAppsRequest, headers);
                    }
                };
                service.getAppsBySearchTag.__http_method = 'GET';
                service.getAppsBySearchTag.__http_url = 'api/v1/apps/search-tags/{search_tag}';
                service.getInstalledApps.__http_method = 'GET';
                service.getInstalledApps.__http_url = 'api/v1/installed-apps';
                service.getKeywordsAndSlugHistory.__http_method = 'GET';
                service.getKeywordsAndSlugHistory.__http_url = 'api/v1/apps/{id_or_slug}/keywords';
                service.managedApps.__http_method = 'GET';
                service.managedApps.__http_url = 'api/v1/managed-apps';
                return service;
            };
        },
        Companies: function () {
            return function (headers) {
                var service = {
                    get: function (getCompaniesRequest) {
                        return httpClient.invoke('GET', 'api/v2/company/{ids_or_slugs}', getCompaniesRequest, headers);
                    }
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = 'api/v2/company/{ids_or_slugs}';
                return service;
            };
        },
        Platforms: function () {
            return function (headers) {
                var service = {
                    delete: function (deletePlatformRequest) {
                        return httpClient.invoke('DELETE', 'api/v2/platform', deletePlatformRequest, headers);
                    },
                    get: function (getPlatformRequest) {
                        return httpClient.invoke('GET', 'api/v2/platform', getPlatformRequest, headers);
                    },
                    getContainer: function (getContainerRequest) {
                        return httpClient.invoke('GET', 'api/v2/container', getContainerRequest, headers);
                    },
                    updateTranslation: function (getPlatformRequest) {
                        return httpClient.invoke('POST', 'api/v2/platform/translate/{name}', getPlatformRequest, headers);
                    },
                    upsert: function (upsertPlatformRequest) {
                        return httpClient.invoke('PUT', 'api/v2/platform', upsertPlatformRequest, headers);
                    }
                };
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = 'api/v2/platform';
                service.get.__http_method = 'GET';
                service.get.__http_url = 'api/v2/platform';
                service.getContainer.__http_method = 'GET';
                service.getContainer.__http_url = 'api/v2/container';
                service.updateTranslation.__http_method = 'POST';
                service.updateTranslation.__http_url = 'api/v2/platform/translate/{name}';
                service.upsert.__http_method = 'PUT';
                service.upsert.__http_url = 'api/v2/platform';
                return service;
            };
        },
        Tags: function () {
            return function (headers) {
                var service = {
                    add: function (addTagRequest) {
                        return httpClient.invoke('POST', 'api/v2/tags', addTagRequest, headers);
                    },
                    delete: function (tagSlugRequest) {
                        return httpClient.invoke('DELETE', 'api/v2/tags', tagSlugRequest, headers);
                    },
                    get: function (getTagsRequest) {
                        return httpClient.invoke('GET', 'api/v2/tags', getTagsRequest, headers);
                    },
                    getCategories: function (getCategoriesRequest) {
                        return httpClient.invoke('GET', 'api/v2/categories', getCategoriesRequest, headers);
                    },
                    getTagBySlug: function (tagSlugRequest) {
                        return httpClient.invoke('GET', 'api/v2/tags/get/{slug}', tagSlugRequest, headers);
                    },
                    removeTagFormApp: function (deleteAppRequest) {
                        return httpClient.invoke('DELETE', 'api/v2/tags/{tag_slug}/apps/{app_slug}', deleteAppRequest, headers);
                    },
                    tagAnApp: function (appRequest) {
                        return httpClient.invoke('POST', 'api/v2/tags/app', appRequest, headers);
                    },
                    update: function (updateTagRequest) {
                        return httpClient.invoke('PUT', 'api/v2/tags', updateTagRequest, headers);
                    },
                    updateTagOfApp: function (appRequest) {
                        return httpClient.invoke('PUT', 'api/v2/tags/app', appRequest, headers);
                    },
                    updateTranslation: function (updateTranslationRequest) {
                        return httpClient.invoke('POST', 'api/v2/tags/translate/{slug}', updateTranslationRequest, headers);
                    }
                };
                service.add.__http_method = 'POST';
                service.add.__http_url = 'api/v2/tags';
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = 'api/v2/tags';
                service.get.__http_method = 'GET';
                service.get.__http_url = 'api/v2/tags';
                service.getCategories.__http_method = 'GET';
                service.getCategories.__http_url = 'api/v2/categories';
                service.getTagBySlug.__http_method = 'GET';
                service.getTagBySlug.__http_url = 'api/v2/tags/get/{slug}';
                service.removeTagFormApp.__http_method = 'DELETE';
                service.removeTagFormApp.__http_url = 'api/v2/tags/{tag_slug}/apps/{app_slug}';
                service.tagAnApp.__http_method = 'POST';
                service.tagAnApp.__http_url = 'api/v2/tags/app';
                service.update.__http_method = 'PUT';
                service.update.__http_url = 'api/v2/tags';
                service.updateTagOfApp.__http_method = 'PUT';
                service.updateTagOfApp.__http_url = 'api/v2/tags/app';
                service.updateTranslation.__http_method = 'POST';
                service.updateTranslation.__http_url = 'api/v2/tags/translate/{slug}';
                return service;
            };
        },
        WebSolutions: function () {
            return function (headers) {
                var service = {
                    get: function (getWebSolutionsRequest) {
                        return httpClient.invoke('GET', 'api/v2/web-solutions/{ids_or_slugs}', getWebSolutionsRequest, headers);
                    },
                    getRecommendedWebSolutions: function (getRecommendedWebSolutionsRequest) {
                        return httpClient.invoke('GET', 'api/v2/web-solutions/recommended/{ms_id}', getRecommendedWebSolutionsRequest, headers);
                    },
                    getWebSolutionsBase: function (getWebSolutionsRequest) {
                        return httpClient.invoke('GET', 'api/v2/web-solutions-base/{ids_or_slugs}', getWebSolutionsRequest, headers);
                    },
                    getWebSolutionsByTags: function (getWebSolutionsByTagsRequest) {
                        return httpClient.invoke('GET', 'api/v2/web-solutions/tags/{tags_slug}', getWebSolutionsByTagsRequest, headers);
                    }
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = 'api/v2/web-solutions/{ids_or_slugs}';
                service.getRecommendedWebSolutions.__http_method = 'GET';
                service.getRecommendedWebSolutions.__http_url = 'api/v2/web-solutions/recommended/{ms_id}';
                service.getWebSolutionsBase.__http_method = 'GET';
                service.getWebSolutionsBase.__http_url = 'api/v2/web-solutions-base/{ids_or_slugs}';
                service.getWebSolutionsByTags.__http_method = 'GET';
                service.getWebSolutionsByTags.__http_url = 'api/v2/web-solutions/tags/{tags_slug}';
                return service;
            };
        }
    };
};
exports.AppMarketApi.__transport = 'http';
__export(require("./types"));
